<template>
	<div>
        <b-overlay :show="loading" no-wrap></b-overlay>
        <form >
            <b-form-group :label="$t('users.name')+':'">
                <b-input
                    v-model="form.name">
                </b-input>
            </b-form-group>
            <b-form-group :label="$t('users.lastName')+':'">
                <b-input
                v-model="form.lastName">
            </b-input>
            </b-form-group>
            <b-row>
                <b-form-group :label="$t('users.phone')+':'" class="col col-12 col-lg-6">
                    <b-input
                    v-model="form.phone">
                    </b-input>
                </b-form-group>
                 <b-form-group :label="$t('users.email')+':'" class="col col-lg-6">
                    <b-input
                        v-model="form.email">
                    </b-input>
                </b-form-group>
            </b-row>
            <b-button variant="primary" @click="save" block class="mt-2">{{ $t('global.save') }}</b-button>
        </form>
	</div>
</template>

<script>
import api from "../../../../api.js"
export default {
    name: 'formDriver',
	components: {
	},
	props: {
		supplierId: {
            required: false,
            default: -1
        }
	},
	data(){
		return {
            loading:false,
            form:{name:"",lastName:"",email:"example@gmail.com",phone:""}
        }
	},
	methods: {
        save(){
            if(this.validate()) {
                this.loading = true;
                api(this).post(`tracking/drivers/`,this.filters)
                .then( (res) => {
                    this.$root.showAlert(this.$t('global.correctlyAdded'))
                    let data = res.data;
                    this.$emit("saved",{...data});
                })
                .catch(this.$root.handleRequestError)
                .finally(()=> {
                    this.loading = false;
                })
            }
        },
        validate(){
			try{
				if (this.isEmpty(this.form.name)) {
					throw this.$t('validations.nameRequired');
				}
                if (this.isEmpty(this.form.lastName)) {
					throw this.$t('validations.lastNameRequired');
				}
                if(this.isEmpty(this.form.phone)) {
					throw this.$t('validations.phoneRequired');
				}
                if (this.isEmpty(this.form.email)) {
					throw this.$t('validations.emailRequired');
				}
			}catch(err) {
				this.$root.showAlert(err,{variant:'danger'})
				return false;
			}
			return true;
		},
		isEmpty(val) {
			return (val ===null || val === undefined || val==="");
		}
	},
	computed:{
        filters() {
            return this.form
        }
	},
	mounted() {}
}
</script>
